<div>
  <app-liste-generique [proprietesAffichees]="proprietesAfficheesSismograph" [listeObjets]="tabSismograph()" (clicObjetEvent)="ouvrirModale($event)"></app-liste-generique>
  <button class="btn btn-primary" (click)="ouvrirModale(undefined)"><i class="fas fa-plus" style="padding-right: 5px;"></i>{{'GLOBAL.AJOUTER' | translate}}</button>
</div>


